import { getLWPService } from "VSS/LWP";
import { showWorkItemDialogById } from "WorkItemTracking/SharedScripts/WorkItemDialogShim";
import * as WITControls_Async from "WorkItemTracking/Scripts/TFS.WorkItemTracking.Controls";

/**
 * Shows work item in a modal view.
 * It will show workitem either in dialog mode or panel mode depending on if user has social work item feature turned on
 * @param workItemId ID of the work item
 * @param options Optional options to be passed to the modal. Casting it as "any" as it can either be work item dialog options (from old plat) or work item panel options (from new plat)
 */
export function showWorkItemModal(workItemId: number, dialogOptions?: WITControls_Async.IWorkItemDialogOptions, panelOptions?: any) {
  const workItemService = getLWPService("work-item-service");

  // if workItemService cannot be loaded, which will happen for old hubs (like old boards/backlogs hub), then render the dialog.
  if (workItemService) {
    workItemService.openWorkItem(workItemId, dialogOptions, panelOptions);
  } else {
    showWorkItemDialogById(workItemId, null, dialogOptions);
  }
}